import createToolkitTheme from '../createToolkitTheme';
var defaultTheme = createToolkitTheme('light');
export default defaultTheme;